export default {
    system: {
        webTitleDev: 'Property Management System (Testing)',
        webTitle: 'Property Management System',
		logout: 'Log out',
		cancel: 'Cancel',
		primaryColor: 'Primary color',
		weakMode: 'Weak Mode',
		layout: 'Layout',
		pageLayout: 'Page layout',
		pleaseSelect: 'Please select',
		default: 'Default',
		fullWidth: 'Full width',
		multiColumn: 'Multi column',
		classic: 'Classic',
		dock: 'Horizontal',
		float: 'Float',
		collapseMenu: 'Collapse Menu',
		showLabels: 'Show Labels',
    },
	login: {
		signInTitle: 'Sign in',
		accountLogin: 'Account sign in',
		rememberMe: 'Remember me',
		forgetPassword: 'Forget password',
		signIn: 'Sign in',
		signInOther: 'Sign in with',
		userPlaceholder: 'user / phone / email',
		userError: 'Please input a user name',
		PWPlaceholder: 'Please input a password',
		codePlaceholder: 'Please input a code',
		PWError: 'Please input a password',
		codeError: 'Please input a code',
		backLogin: 'Return to Login'
	},
	user: {
		dynamic: 'Dynamic',
		info: 'User Info',
		settings: 'Settings',
		thememode: 'Theme Mode',
		nightmode: 'Night Mode',
		nightmode_msg: 'Suitable for low light environment,The current night mode is beta',
		language: 'Language',
		language_msg: 'Translation in progress,Temporarily translated the text of this view',
	}
}
